/**
 * Interpolare între ultimele două stări ale fizicii. Randarea rămâne cu un
 * interval de publicare în urma fizicii, dar mișcarea e fluidă indiferent de
 * frecvența ecranului.
 */
export class StateTimeline {
  private lastSeq = -1;
  private arrivedLatest = 0;
  private interval = 4;

  /** Apelat la fiecare cadru cu numărul de secvență publicat de worker. Întoarce true dacă a sosit o stare nouă. */
  observe(seq: number, now: number): boolean {
    if (seq === this.lastSeq) return false;
    if (this.lastSeq >= 0) {
      const dt = now - this.arrivedLatest;
      this.interval += (clamp(dt, 1, 50) - this.interval) * 0.2;
    }
    this.arrivedLatest = now;
    this.lastSeq = seq;
    return true;
  }

  /** Fracția 0..1 dintre starea anterioară și cea mai nouă. */
  alpha(now: number): number {
    return clamp((now - this.arrivedLatest) / this.interval, 0, 1);
  }

  get seq(): number {
    return this.lastSeq;
  }
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

/** out[i] = a[i] + (b[i] - a[i]) * t, pentru n valori începând de la offseturile date. */
export function lerpInto(out: Float32Array, a: Float32Array, aOff: number, b: Float32Array, bOff: number, n: number, t: number): void {
  for (let i = 0; i < n; i++) {
    const x = a[aOff + i];
    out[i] = x + (b[bOff + i] - x) * t;
  }
}
